import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux";
import { Accordion } from "react-bootstrap";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import * as markingApi from "../../../api/markingApi";
import { isEmptyArray, isEmptyObject } from "../../../util";
import { Common } from "../../../helper/"
import { LoadingSpinner } from "../../Shared";

import "../../../assets/stlyes/StudentGraph/MainTargets.scss";

import keyIcon from "../../../assets/images/MainTargetKeyIcon.svg"
import SaveIcon from "../../../assets/images/Save.png";
import DismissIcon from "../../../assets/images/Dismiss.svg";
import TargetUnselected from "../../../assets/images/TargetUnselected.svg"
import TargetSelected from "../../../assets/images/TargetSelected.svg"

const MainTargets = (props) => {
  const { eventKey } = props;
  const [result, setResult] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [support, setSupport] = useState([]);
  const [openAccordionIndex, setOpenAccordionIndex] = useState(eventKey);
  const [openSubAccordionIndex, setOpenSubAccordionIndex] = useState(null);
  const userData = useSelector((state) => state.pupilProgress.pupilInfo);

  const getTargets = async () => {
    setIsLoading(true);
    const getResult = await markingApi.fetchTargetForParticularSubjectAndYear({ pupilId: userData.id, year: parseInt(userData.year) });
    if (!isEmptyObject(getResult.Items)) {
      setResult(getResult.Items.targetsToDisplay);
      setSupport(getResult.Items.selectedTargets);
    }
    setIsLoading(false);
  }
  useEffect(() => {
    getTargets();
  }, [])

  const mergedStyles = (j) => {
    let k = j.charAt(j.length - 1);
    return {
      backgroundColor: k === "A" ? "var(--absent-colour)" : k === "B" ? "var(--below-colour)" : k === "W" ? "var(--emerging-colour)" : k === "E" ? "var(--expected-colour)" : k === "G" ? "var(--greater-colour)" : "",
    };
  };

  const submitSaveHandler = async () => {
    setIsLoading(true);
    await markingApi.updateTargetForParticularSubjectAndYear({ pupilId: userData.id, year: parseInt(userData.year), subjectName: support });
    setIsLoading(false);
  }

  const submitCancelHandler = () => {
    getTargets();
  }

  const targetSelect = (subject, category, name, marking, target) => {
    let desc = [{ name, marking, target }];
    const obj = {
      name: subject,
      category: [{
        name: category,
        descriptions: desc
      }],
    }
    const same = support?.flatMap(s => s.category?.flatMap(c => c.descriptions?.filter(d => d.target === target)))
    let data = [...support]
    if (data.length !== 0) {
      if (isEmptyObject(same) || isEmptyArray(same)) {
        const existingSubject = data.find((s) => s.name === subject);
        if (existingSubject) {
          const existingCategory = existingSubject.category.find((c) => c.name === category);
          if (existingCategory) {
            existingCategory.descriptions.push({ name, marking, target });
          } else {
            existingSubject.category.push({
              name: category,
              descriptions: desc,
            });
          }
        } else {
          data.push(obj);
        }
        setSupport(data);
      }
    } else {
      data.push(obj);
      setSupport(data);
    }
  }

  const targetUnSelect = (subject, category, name, marking, target) => {
    const descriptionsToRemove = support?.flatMap((s) =>
      s.category?.flatMap((c) =>
        c.descriptions?.filter((d) => d.target === target)
          .map((desc) => ({
            subjectName: s.name,
            category: c.name,
            name: desc.name,
            marking: desc.marking,
            target: desc.target
          }))
      )
    );
    let updatedSupport = [...support];
    for (const descriptionToRemove of descriptionsToRemove) {
      const subjectIndex = updatedSupport?.findIndex((s) => s.name === descriptionToRemove.subjectName);
      if (subjectIndex !== -1) {
        const categoryIndex = updatedSupport[subjectIndex].category?.findIndex((c) => c.name === descriptionToRemove.category);
        if (categoryIndex !== -1) {
          const descriptionIndex = updatedSupport[subjectIndex].category[categoryIndex].descriptions?.findIndex((d) => d.target === descriptionToRemove.target);
          if (descriptionIndex !== -1) {
            updatedSupport[subjectIndex].category[categoryIndex].descriptions.splice(descriptionIndex, 1);
          }
          if (updatedSupport[subjectIndex].category[categoryIndex].descriptions.length === 0) {
            updatedSupport[subjectIndex].category.splice(categoryIndex, 1);
          }
        }
      }
    }
    setSupport(updatedSupport);
  };
  return (
    isLoading ? <LoadingSpinner /> : <div className="mainTargetMainPage">
      <div className="mainTargetSubmitButton">
        <button type="submit" className="mainTargetSaveButton" onClick={submitSaveHandler}>
          <img src={SaveIcon} alt="Save" />
          <p className="d-flex justify-content-center align-items-center">
            {Common.Save}
          </p></button>
        <button type="submit" className="mainTargetCancelButton" onClick={submitCancelHandler}>
          <img src={DismissIcon} alt="Cancel" />
          <p className="d-flex justify-content-center align-items-center">
            {Common.Cancel}
          </p></button>
      </div>
      <div className="k">
        {result?.map((sub, i) => {
          return (
            <div key={i}>
              <Accordion className={`mainTargetCategory ${sub.subject}`} activeKey={openAccordionIndex === i ? i + 1 : ""} onSelect={() => setOpenAccordionIndex(openAccordionIndex === i ? null : i)}>
                <Accordion.Item eventKey={i + 1} >
                  <Accordion.Header className="accordion-header" >
                    <h4 className={`mainTargetSubjectNameOne One${sub.subject}`}>{`${sub.subject}`}</h4>
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      className={`accordion-icon ${openAccordionIndex === i ? `One${sub.subject}` : "rotate"}`}
                    />
                  </Accordion.Header>
                  <Accordion.Body className="mainTargetFirstAccBody" >
                    {sub.category?.map((cat, j) => {
                      return (
                        <div key={j} className="mainTargetFirstAcc">
                          <Accordion className="mainTargetAccordion" activeKey={openSubAccordionIndex === `${i}-${j}` ? `${i}-${j}` : ""} onSelect={() => setOpenSubAccordionIndex(openSubAccordionIndex === `${i}-${j}` ? null : `${i}-${j}`)}>
                            <Accordion.Item eventKey={`${i}-${j}`}>
                              <div className="d-flex">
                                <Accordion.Header >
                                  <div className="mainTargetCategoryAccordionHeader">{cat.name}</div>
                                  <FontAwesomeIcon
                                    icon={faChevronUp}
                                    className={`accordion-icon ${openSubAccordionIndex === `${i}-${j}` ? "" : "rotate"}`}
                                  />
                                </Accordion.Header><div className="d-flex align-items-center">{j === 0 ? <span className="mainTargetTargetLevelHeading">{Common.TargetLevel}</span> : <></>}</div>
                              </div>
                              {cat.descriptions.map((desc, k) => {
                                return (
                                  <Accordion.Body key={k} className="mainTargetCategoryAccordionBody">
                                    <div className="d-flex">
                                      {(isEmptyArray(support?.flatMap(s => s.category?.flatMap(c => c.descriptions?.filter(d => d.target === desc.target || d.name === desc.name))))) ? <span role="button" tabIndex={0} onKeyDown={e => { e.key === "Enter" && targetSelect(sub.subject, cat.name, desc.name, desc.marking, desc.target) }} className="mainTargetUnselectedImage" onClick={() => targetSelect(sub.subject, cat.name, desc.name, desc.marking, desc.target)} > <img src={TargetUnselected} alt="TargetUnselected" /></span> : <span role="button" tabIndex={0} onKeyDown={e => { e.key === "Enter" && targetUnSelect(sub.subject, cat.name, desc.name, desc.marking, desc.target) }} className="mainTargetUnselectedImage" onClick={() => targetUnSelect(sub.subject, cat.name, desc.name, desc.marking, desc.target)} > <img src={TargetSelected} alt="TargetUnselected" /></span>}
                                      <div className="mainTargetCategoryTargets"><span className="mainTargetCategoryDescription">{desc.name}: {desc.target}</span>
                                        <span>{desc.isKPI ? <span className="mainTargetKeyIcon">{<img className="mainTargetKeyIcon" src={keyIcon} alt="KeyIcon" />}</span> : ""}</span>
                                      </div>
                                      <span className="mainTargetCategoryMarking" style={mergedStyles(desc.marking)}><span className="mainTargetCategoryMarkingInner">{desc.marking}</span></span>
                                    </div>
                                  </Accordion.Body>
                                )
                              })}
                            </Accordion.Item>
                          </Accordion>
                        </div>
                      )
                    })}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          )
        }
        )}
      </div>
    </div>
  );
}

export default MainTargets
